export const MENSAGEM_FORMATO_DOCUMENTO = 'Formato não permitido. Para Contracheque, RG e CNH (frente e verso), selecione um arquivo PNG, JPG/JPEG ou PDF.';

export const documentoComFormatoRestrito = (tipo: number): boolean =>
  [1, 2, 4, 5, 20].includes(tipo);

export const formatoDocumentoInvalido = (tipo: number, nome: string): boolean =>
  documentoComFormatoRestrito(tipo) && !/\.(png|jpe?g|pdf)$/i.test(nome);
